export const GET_FACILITIES_REQUEST = 'GET_FACILITIES_REQUEST';
export const GET_FACILITIES_SUCCESS = 'GET_FACILITIES_SUCCESS';
export const GET_FACILITIES_FAILURE = 'GET_FACILITIES_FAILURE';
export const REQUEST_ACCESS_REQUEST = 'REQUEST_ACCESS_REQUEST';
export const REQUEST_ACCESS_FAILURE = 'REQUEST_ACCESS_FAILURE';
export const GET_FACILITY_USERS_LIST_FAILURE = 'GET_FACILITY_USERS_LIST_FAILURE';
export const GET_FACILITY_BY_ID_REQUEST = 'GET_FACILITY_BY_ID_REQUEST';
export const GET_FACILITY_BY_ID_SUCCESS = 'GET_FACILITY_BY_ID_SUCCESS';
export const GET_FACILITY_BY_ID_FAILURE = 'GET_FACILITY_BY_ID_FAILURE';
export const GET_FACILITY_USERS_LIST_REQUEST = 'GET_FACILITY_USERS_LIST_REQUEST';
export const GET_FACILITY_USERS_LIST_SUCCESS = 'GET_FACILITY_USERS_LIST_SUCCESS';
export const GET_USERS_FOR_FACILITY_REQUEST = 'GET_USERS_FOR_FACILITY_REQUEST';
export const GET_USERS_FOR_FACILITY_SUCCESS = 'GET_USERS_FOR_FACILITY_SUCCESS';
export const GET_USERS_FOR_FACILITY_FAILURE = 'GET_USERS_FOR_FACILITY_FAILURE';
export const GET_ACTIVE_FACILITIES_REQUEST = 'GET_ACTIVE_FACILITIES_REQUEST';
export const GET_ACTIVE_FACILITIES_SUCCESS = 'GET_ACTIVE_FACILITIES_SUCCESS';
export const GET_ACTIVE_FACILITIES_FAILURE = 'GET_ACTIVE_FACILITIES_FAILURE';
export const GET_FACILITY_DATA_REQUEST = 'GET_FACILITY_DATA_REQUEST';
export const GET_FACILITY_DATA_SUCCESS = 'GET_FACILITY_DATA_SUCCESS';
export const GET_FACILITY_DATA_FAILURE = 'GET_FACILITY_DATA_FAILURE';
export const GET_NAVIGATION_MENUS_REQUEST = 'GET_NAVIGATION_MENUS_REQUEST';
export const GET_NAVIGATION_MENUS_SUCCESS = 'GET_NAVIGATION_MENUS_SUCCESS';
export const GET_NAVIGATION_MENUS_FAILURE = 'GET_NAVIGATION_MENUS_FAILURE';
export const CREATE_NAVIGATION_MENUS_REQUEST = 'CREATE_NAVIGATION_MENUS_REQUEST';
export const CREATE_NAVIGATION_MENUS_SUCCESS = 'CREATE_NAVIGATION_MENUS_SUCCESS';
export const CREATE_NAVIGATION_MENUS_FAILURE = 'CREATE_NAVIGATION_MENUS_FAILURE';